var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgblog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 448,
    viewBox: "0 0 455 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455 368C455 412.183 419.183 448 375 448H0.353516C31.4551 448 48.917 404.432 33.4092 377.473C12.1562 340.526 0 297.683 0 252C0 112.824 112.824 0 252 0C299.214 0 343.396 12.9841 381.168 35.5764C408.506 51.9275 455 34.103 455 2.24854V368Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgblog);
export default __webpack_public_path__ + "static/media/bgblog.7c8fabc3fba3216ac06fd73a6fd74f8f.svg";
export { ForwardRef as ReactComponent };